import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjId, subTypeCode, sVer} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = () => openWindow(
        '/Ai',

        {
            bizMap: {},
            prjId,
            scene: 'GENERATE_ASD',
            sVer,
        }
    )

    return {
        label: '设计系统架构',
        onClick,
    }
}
